import ComingWithVideoBgContainer from "../../Componant/ComingSoon/ComingWithVideoBg";

const ComingWithVideoBg = () => {
  return (
    <div className="page-wrapper compact-wrapper">
      <ComingWithVideoBgContainer />
    </div>
  );
};

export default ComingWithVideoBg;
